/* ═══════════════════════════════════════════════════════════════════════════
   TRANG GÓP Ý (người chấm dưới ngưỡng) — phần chạy. Chiến dịch 107.

   Phần nhìn thấy dựng bằng Liquid trong `sections/pheu-107-gop-y.liquid`.
   Không tự gọi mạng — nối backend thì sửa `assets/pheu-107-gui.js`.
   🗓️ Xoá cùng cả bộ `pheu-107-*` khi chiến dịch đóng.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var goc = document.querySelector('[data-gy7]');
  if (!goc) return;

  var form  = goc.querySelector('[data-gy7-form]');
  var nut   = goc.querySelector('[data-gy7-gui]');
  var oLoi  = goc.querySelector('[data-gy7-loi]');
  var oXong = goc.querySelector('[data-gy7-xong]');
  var oSai  = goc.querySelector('[data-gy7-sai]');
  var oSua  = goc.querySelector('[data-gy7-sua]');
  var oDiem = goc.querySelector('[data-gy7-diem]');
  var nutLui= goc.querySelector('[data-gy7-lui]');
  if (!form) return;

  var CHU = {
    trong:   'Write something first — anything at all.',
    khongGui:'We could not save that just now. Reply straight to our email and we will read it there.'
  };

  /* ── Nhắc lại điểm vừa chấm ──────────────────────────────────────────────────
     Lấy từ bộ nhớ phiên do `pheu-107-feedback.js` cất lại. Nhắc lại để khách biết mình
     đang nói tiếp câu chuyện nào — vào thẳng trang này mà không có ngữ cảnh thì hai ô trống
     hiện ra như một cuộc thẩm vấn.

     Kiểm là số 1–5 rồi mới in: giá trị đến từ bộ nhớ trình duyệt, tức là chỗ người khác
     sửa được. In thẳng ra là để người lạ viết chữ lên trang của mình. */
  try {
    var d = parseInt(sessionStorage.getItem('ms107_diem'), 10);
    var mau = goc.getAttribute('data-mau-diem') || '';
    if (d >= 1 && d <= 5 && mau && oDiem) {
      oDiem.textContent = mau.replace('{diem}', String(d));
      oDiem.removeAttribute('hidden');
    }
  } catch (e) {}

  /* Đường về trang đọc. Chỉ nhận đường dẫn nội bộ — cùng lối phòng thủ với các trang kia. */
  (function () {
    var l = (goc.getAttribute('data-dich-lui') || '').trim();
    if (!nutLui || l.charAt(0) !== '/' || l.charAt(1) === '/') return;
    var ma = window.MS107 ? window.MS107.phien() : '';
    nutLui.setAttribute('href', l + (ma ? '#s=' + encodeURIComponent(ma) : ''));
    nutLui.removeAttribute('hidden');
  })();

  function donLoi() { oLoi.setAttribute('hidden', ''); }
  oSai.addEventListener('input', donLoi);
  oSua.addEventListener('input', donLoi);

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var sai = (oSai.value || '').trim().slice(0, 4000);
    var sua = (oSua.value || '').trim().slice(0, 4000);

    /* Không ô nào bắt buộc, nhưng gửi một biểu mẫu trống thì không có gì để gửi. Nói thẳng
       thay vì im lặng nhận — im lặng nhận là để khách tưởng đã góp ý xong. */
    if (!sai && !sua) {
      oLoi.textContent = CHU.trong;
      oLoi.removeAttribute('hidden');
      try { oSai.focus(); } catch (e2) {}
      return;
    }

    nut.disabled = true;
    nut.setAttribute('aria-busy', 'true');

    var diem = 0;
    try { diem = parseInt(sessionStorage.getItem('ms107_diem'), 10) || 0; } catch (e3) {}

    var loiHua = window.MS107
      ? window.MS107.gui('feedback_low_detail', { diem: diem, khong_dung: sai, can_sua: sua })
      : Promise.resolve(false);

    loiHua['catch'](function () { return false; }).then(function (xong) {
      nut.disabled = false;
      nut.removeAttribute('aria-busy');

      if (!xong) {
        oLoi.textContent = CHU.khongGui;
        oLoi.removeAttribute('hidden');
      }

      form.setAttribute('hidden', '');
      oXong.removeAttribute('hidden');
      try { oXong.querySelector('h2').focus(); } catch (e4) {}
    });
  });
})();
